'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UITileSection;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function UITileSection(_ref) {
  var className = _ref.className,
      children = _ref.children,
      flush = _ref.flush,
      rest = _objectWithoutProperties(_ref, ['className', 'children', 'flush']);

  return _react2.default.createElement(
    'div',
    _extends({}, rest, {
      className: (0, _reactUtils.classNames)('private-tile__section', 'has--vertical-spacing', className, {
        'private-tile__section--flush': flush
      })
    }),
    children
  );
}

UITileSection.defaultProps = {
  flush: false
};

UITileSection.propTypes = {
  children: _react.PropTypes.node,
  className: _react.PropTypes.string,
  flush: _react.PropTypes.bool
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/tile/UITileSection.js
// module id = 488
// module chunks = 0